function collectCartSections() {
  var sections = new Map();
  var tags = ['cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification'];
  var skip = new Set(['cart-drawer:cart-drawer','cart-drawer-items:CartDrawer','cart-items:main-cart-items']);
  document.querySelectorAll(tags.join(',')).forEach(function(el) {
    var entries;
    try { entries = el.getSectionsToRender ? el.getSectionsToRender() : []; } catch(e) { return; }
    var tag = el.tagName.toLowerCase();
    (entries || []).forEach(function(entry) {
      if (skip.has(tag + ':' + entry.id)) return;
      var sectionId = entry.section || entry.id;
      if (!sectionId || sections.has(sectionId)) return;
      var root = entry.section ? document.getElementById(entry.id) : document;
      if (!root) return;
      var mount = entry.selector ? (root.querySelector(entry.selector) || (entry.section ? root : null)) : document.getElementById(entry.id);
      if (!mount) return;
      sections.set(sectionId, { mount: mount, extractSelector: entry.selector || '.shopify-section' });
    });
  });
  return sections;
}

function refreshDawnCartUI() {
  var sections = collectCartSections();
  var keys = [];
  sections.forEach(function(v, k) { keys.push(k); });
  var cartUrl = (typeof routes !== 'undefined' && routes && routes.cart_url) ? routes.cart_url : '/cart';
  var url = cartUrl + '.js' + (keys.length ? '?sections=' + keys.join(',') : '');
  return fetch(url, { headers: { Accept: 'application/json' } })
    .then(function(r) { return r.ok ? r.json() : null; })
    .catch(function() { return null; })
    .then(function(cartData) {
      if (cartData && cartData.sections) {
        sections.forEach(function(val, id) {
          var html = cartData.sections[id];
          if (!html) return;
          var source = new DOMParser().parseFromString(html, 'text/html').querySelector(val.extractSelector);
          if (source) {
            val.mount.innerHTML = '';
            var nodes = source.childNodes;
            for (var i = 0; i < nodes.length; i++) {
              val.mount.appendChild(nodes[i].cloneNode(true));
            }
          }
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-refresh', cartData: cartData || undefined });
    });
}

function initStandardActions() {
  var actions = window.Shopify && window.Shopify.actions;
  if (!actions) return;
  actions.openCart.configure({
    handler: function(defaultHandler) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return Promise.resolve(); }
      return defaultHandler();
    }
  });
  actions.updateCart.configure({
    eventTarget: function() { return document; },
    handler: function(defaultHandler) {
      return defaultHandler().then(function(result) {
        return refreshDawnCartUI().then(function() { return result; });
      }).catch(function(error) {
        console.error('[Dawn] Standard Actions cart refresh failed; reloading.', error);
        window.location.reload();
      });
    }
  });
}

if (window.Shopify && window.Shopify.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}
